export const FREIGHT_CALCULATION_OPTIONS = [
  { label: 'Longest Leg', value: 'longest_leg' },
  { label: 'Sum All Legs', value: 'sum_of_legs' },
  { label: 'Highest Rate', value: 'highest_rate' },
  { label: 'By Lane', value: 'by_lane' },
]

export const FREIGHT_DATE_METHOD_OPTIONS = [
  { label: 'Load Date', value: 'load_date' },
  { label: 'Delivery Date', value: 'delivery_date' },
]

export const COMBINED_MINIMUM_METHOD_OPTIONS = [
  { label: 'Gas Rate', value: 'Gas Rate' },
  { label: 'Diesel Rate', value: 'Diesel Rate' },
  { label: 'Highest Rate', value: 'Highest Rate' },
]
